import staticSchemas from '~/data/schema.json'

export function useStaticSchema(pageKey) {
  const schema = staticSchemas[pageKey]

  if (!schema) {
    console.warn(`[useStaticSchema] No schema found for key: ${pageKey}`)
    return
  }

  useHead({
    script: [
      {
        type: 'application/ld+json',
        children: JSON.stringify(schema)
      }
    ]
  })
}
